import React, { useEffect } from 'react';
import { BannerType, PageLayout } from '..';
import { BodyContainer, InvoicePanel, PaymentPanel, RightContainer } from './style';
import { LeftContainer } from './style';
import { Container } from './style';
import Banner from '@/components/Banner';
import Summary from '@/components/Summary';
import Terms from '@/components/Terms';
import Payment from '@/components/Payment';
import { airTracker } from '@/utils/airTracker';
import { COMPONENT_NAME } from '@/pages/Main';
import InvoiceDetails from '@/components/Invoice';

type Props = {
  layout: PageLayout;
  bannerType: BannerType;
};
const DesktopLayout = ({ layout, bannerType }: Props) => {
  useEffect(() => {
    airTracker.info('Enter DesktopLayout', { component: COMPONENT_NAME, layout, bannerType });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <LeftContainer hasBanner={bannerType !== BannerType.NONE} isOnePageLayout={layout === PageLayout.ONE_PAGE}>
        <BodyContainer>
          <InvoicePanel>
            <Banner bannerType={bannerType} />
            <Summary />
            <InvoiceDetails />
          </InvoicePanel>
          <Terms />
        </BodyContainer>
      </LeftContainer>
      {layout === PageLayout.TWO_PAGE && (
        <RightContainer>
          <PaymentPanel>
            <Payment />
          </PaymentPanel>
        </RightContainer>
      )}
    </Container>
  );
};

export default DesktopLayout;
